<template>
  <b-col md="4">
    <div v-if="isVideo" class="position-relative uploader-preview">
      <video-player :url="videoUrl" height="250"/>
      <div class="position-absolute w-100 h-100 pointer-events-none">
        <div class="d-flex flex-column justify-content-between h-100">
          <div class="d-flex justify-content-end">
            <b-button-close @click.prevent.stop="removeFile" style="pointer-events: auto"/>
          </div>
          <b-progress :value="fileProgress" :max="100" :class="{'hidden': progressBarHidden}"/>
        </div>

      </div>
    </div>
    <div v-else-if="isIllustration" class="uploader-preview bg-lighter-gray d-flex justify-content-between flex-column">
      <div class="d-flex justify-content-end w-100">
        <b-button-close @click.prevent.stop="removeFile"/>
      </div>
      <div class="d-flex justify-content-center align-items-center flex-column">
        <i class="fas fa-pen-nib fa-3x"></i>
        {{file.name}}
      </div>
      <div></div>

    </div>
    <div v-else class="uploader-preview" :style="previewImageStyle" :class="{'fade': fileError || isRemoving}">
      <b-button-close @click.prevent.stop="removeFile"/>
      <b-progress :value="fileProgress" :max="100" :class="{'hidden': progressBarHidden}"/>
    </div>
  </b-col>
</template>

<script>
import VideoPlayer from "../../Common/VideoPlayer";

export default {
  components: {VideoPlayer},
  props: ['file'],

  data: function () {
    return {
      progressBarHidden: true
    }
  },

  computed: {
    existingModelAttributes() {
      if (this.file && this.file._file && this.file._file.attributes) {
        return this.file._file.attributes
      }

      return null
    },

    videoUrl() {
      if (this.isVideo) {
        if (this.file._file instanceof File) {
          return URL.createObjectURL(this.file._file);
        }
      }

      return this.file.asset_url
    },

    isVideo() {
      if (this.existingModelAttributes) {
        return this.existingModelAttributes.asset_type === "video"
      }

      return this.file._file.type === "video/mp4";
    },

    isIllustration() {
      if (this.existingModelAttributes) {
        return this.existingModelAttributes.asset_type === "illustration"
      }

      const illContentTypes = "application/postscript,application/eps,application/x-eps,image/eps,image/x-eps,application/pdf,image/svg+xml"

      return illContentTypes.includes(this.file._file.type)
    },

    fileError: function () {
      return this.file.error
    },

    fileProgress: function () {
      return this.file.progress
    },

    isRemoving: function () {
      return this.file.removing
    },

    previewImageStyle: function () {
      if (this.file.asset_url) {
        return `background-image: url(${this.file.asset_url})`
      }
      //TODO: Set a placeholder image if this is missing
      return ""
    }
  },

  watch: {
    fileProgress: function (val) {
      // This will show the progress bar even if it jumps to 100
      if (val > 0) {
        this.progressBarHidden = false
      }

      // when it gets to 100% hide the progress bar (animated)
      if (val === 100) {
        this.$nextTick(() => {
          this.progressBarHidden = true
        })
      }
    }
  },

  methods: {
    removeFile: function (ev) {
      if (this.isRemoving) return;
      this.file.removing = true
      this.$emit('remove', this.file)
    }
  }
}
</script>